import { render, staticRenderFns } from "./ProductCategoryLink.vue?vue&type=template&id=a5f90aee&scoped=true"
import script from "./ProductCategoryLink.vue?vue&type=script&lang=js"
export * from "./ProductCategoryLink.vue?vue&type=script&lang=js"
import style0 from "./ProductCategoryLink.vue?vue&type=style&index=0&id=a5f90aee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f90aee",
  null
  
)

export default component.exports